import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDashboardThunk } from "../../features/DashboardReducer";

/**Import Styles and Assets */
import styles from "./DashBoard.module.scss";
import dash1 from "./images/dashboard1.svg"
import dash2 from "./images/dashboard2.svg"
import dash3 from "./images/dashboard3.svg"
import dash4 from "./images/dashboard4.svg"
    

/**Import From Antd */
import { Col, Row } from 'antd';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const antIcon = <LoadingOutlined style={{ fontSize: 35, color: "white" }} spin />;

export default function DashBoard() {
    const dispatch = useDispatch();
    const { data, status } = useSelector(state => state.dashboard);

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchDashboardThunk());
        }
    }, []);

    const item = [
        {
            image: dash1,
            number: data?.total_business ? data.total_business : 0,
            info: "Number of businesses",
            color1: "#FF6363",
            color2: "#EA2727"

        },
        {
            image: dash2,
            number: data?.total_users ? data.total_users : 0,
            info: "Number of users",
            color1: "#FFAB63",
            color2: "#FD7500"


        },
        {
            image: dash3,
            number: data?.total_business_posts ? data.total_business_posts : 0,
            info: "Number of business posts",
            color1: "#6393FC",
            color2: "#1860FC"

        },
        {
            image: dash4,
            number: data?.total_user_posts ? data.total_user_posts : 0,
            info: "Number of users posts",
            color1: "#8591F1",
            color2: "#6268F3"

        },
        // {
        //     image: dash5,
        //     number: data?.total_business_reports ? data.total_business_reports : 0,
        //     info: "Number Of Business Report",
        //     color1: "#408BF9",
        //     color2: "#0546A3"

        // }
    ]
    return (
        <div className={styles.dashBoard}>
            <h1 className={styles.contentTitle}>Dashboard</h1>
            <div className={styles.content}>
                <Row gutter={[16, 16]} className={styles.row}>
                    {item.map((i, index) => {
                        return <Card {...{ ...i, status }} index={index} style={(index === 4) ? { width: "44px", height: "44px" } : {}} />
                    })}
                </Row>


            </div>

        </div>
    )
}

export function Card({ image, number, info, color1, color2, status, index, style }) {
    return (
        <Col xxl={6} xl={8} lg={10} sm={20} >
            <div className={styles.card} style={{ backgroundImage: `linear-gradient(180deg, ${color1}, ${color2})` }}>
                <div className={styles.imageBack}>
                    <img src={image} style={style} alt={`Dash Board${index} Image`} />
                </div>
                <h1>{status === "loading" ? <Spin indicator={antIcon} size="large" /> : number}</h1>
                <h4>{info}</h4>

            </div>
        </Col>
    )
}